import { heroBackgroundImage } from "@/assets/images/base64/images.base64"
import breakpoints from "@/constants/breakpoints"

export const overviewWrapper = {
  position: "relative",
  mb: {
    xs: 5,
    sm: 5,
    md: 5,
  },
}

export const heroWrapper = {
  pt: 7.25,
  pb: { xs: 5, md: 23.75 },
  backgroundImage: `url(${heroBackgroundImage})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
}

export const heroTitleImageWrapper = {
  display: "flex",
  justifyContent: "space-between",
}

export const heroTitleWrapper = {
  position: "relative",
  display: "flex",
  alignItems: "start",
  gap: 0.5,
}

export const heroCarretWrapper = {
  alignSelf: "center",
}

export const heroCarretIcon = {
  fontWeight: 700,
  color: "white",
}

export const heroChip = {
  background: "linear-gradient(270deg, #D898EA 0%, #FFEDD7 100%)",
  borderRadius: 2,
  fontWeight: 600,
  fontSize: 14,
  color: "#000",
  px: 0,
  backgroundSize: "200% 200%",
  animation: "shiny-effect 2s infinite",
}

export const heroMenu = {
  minWidth: 144,
  py: 2,
}

export const heroMenuSelectMenuTitle = {
  fontSize: 12,
  color: "#484848",
  px: 2.5,
  py: 0.75,
}

export const heroMenuItemWrapper = {
  display: "flex",
  gap: 1.5,
  alignItems: "center",
  px: 2.5,
  py: 1.25,
}

export const heroMarketTitle = {
  fontSize: 14,
  color: "#484848",
}

export const heroTitle = {
  ml: { xs: 2, md: 4 },
  mb: { xs: 1, md: 2 },
  fontSize: { xs: 24, md: 32, lg: 40 },
  lineHeight: { xs: 1.5, lg: "3.5rem" },
  fontWeight: 700,
  color: "white",
}

export const heroStatsWrapper = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  px: { xs: 3, md: 4 },
  py: { xs: 1.5, md: 3 },
  gap: { xs: 2, md: 6, lg: 15 },
}

export const heroStatsBox = {
  display: "flex",
  alignItems: "center",
  gap: { xs: 2, xl: 3 },
}

export const heroStatsTitle = {
  fontSize: { xs: 14, sm: 16, lg: 18 },
  mb: 1,
  color: "white",
}

export const stats = {
  fontSize: { xs: 16, sm: 20, lg: 24 },
  fontWeight: 700,
  color: "white",
}

export const heroStatIconStyle = (width: number) => {
  if (width >= breakpoints.xl) {
    return {
      marginLeft: "auto",
      marginRight: 100,
    }
  } else if (width >= breakpoints.lg) {
    return {
      marginLeft: "auto",
    }
  }
  return {
    display: "none",
  }
}

export const accountOverviewContainerStyle = (isWalletPublicKeyAvailable = false) => ({
  height: {
    xs: isWalletPublicKeyAvailable ? "auto" : "auto",
    sm: isWalletPublicKeyAvailable ? "auto" : "auto",
    md: isWalletPublicKeyAvailable ? "11rem" : "auto",
    lg: isWalletPublicKeyAvailable ? "11rem" : "9rem",
    xl: isWalletPublicKeyAvailable ? "11rem" : "9rem",
  },
  mt: { xs: 2, md: 0 },
})

export const advertisementContainerStyle = {
  p: 2,
  backgroundColor: "white",
  borderRadius: 4,
}

export const floatingAccountWrapper = (isWalletPublicKeyAvailable = false) => {
  return {
    transform: {
      xs: "translateY(0%)",
      sm: "translateY(0%)",
      md: isWalletPublicKeyAvailable ? "translateY(-50%)" : "translateY(0%)",
      lg: "translateY(-50%)",
      xl: "translateY(-50%)",
    },
  }
}

export const floatingBorrowCheckWrapper = {
  ...floatingAccountWrapper,
  transform: {
    xs: "translateY(-30%)",
    sm: "translateY(-50%)",
    md: "translateY(-50%)",
    lg: "translateY(-20%)",
    xl: "translateY(-20%)",
  },
  height: {
    xs: "auto",
    sm: "auto",
    md: "80%",
  },
}

export const accountBorrowCheckMobileWrapper = {
  mt: 3,
}
